module.exports = __webpack_public_path__ + "static/media/manghe.57f15bcd.svg";